import { useState } from "react";
import { INSURANCE, LENDER_APPRAISAL, LENDER_NON_APPRAISAL, PAY_NOW, DEFER_PAYMENT, MUELLER_INVOICE, COMMERCIAL } from "typeConstants/webOrder";
import Product from "components/WebOrderV2/Product";
import PolicyOrLoan from "components/WebOrderV2/PolicyOrLoan.tsx";
import Homeowner from "components/WebOrderV2/Homeowner";
import Contact from "components/WebOrderV2/Contact";
import Payment from "components/WebOrderV2/Payment";
import SingleProperty from "components/WebOrderV2/SingleProperty";
import MultiProperty from "components/WebOrderV2/MultiProperty";


const useWebOrderSettings = () => {
  const [settings, setSettings] = useState(null);

  const updateSettings = newSettings => {
    setSettings(newSettings);
  };

  const getStartPageLayout = () => {
    let pages = [
      {
        title: "Product",
        component: Product
      },
    ];
    // Add placeholders until we get settings
    for (let i = 0; i < 4; i++){
      pages.push({
        title: "..."
      });
    }
    return pages;
  };

  const getLenderPageLayout =  [
    {
      title: "Product",
      component: Product
    },
    {
      title: "Property",
      component: SingleProperty
    },    
    {
      title: "Loan",
      component: PolicyOrLoan
    },
    {
      title: "Borrower",
      component: Homeowner
    },
    {
      title: "Additional Info",
      component: Contact
    },
    {
      title: "Payment",
        component: Payment
    }
  ];

  const insurancePageLayout = [
    {
      title: "Product",
      component: Product
    },
    {
      title: "Property",
      component: SingleProperty
    },  
    {
      title: "Policy",
      component: PolicyOrLoan
    },
    {
      title: "Insured",
      component: Homeowner
    },
    {
      title: "Additional Info",
      component: Contact
    },
  ];

  const commercialPageLayout = [
    {
      title: "Product",
      component: Product
    },
    {
      title: "Property",
      component: MultiProperty
    },
    {
      title: "Policy",
      component: PolicyOrLoan
    },
    {
      title: "Insured",
      component: Homeowner
    },
    {
      title: "Additional Info",
      component: Contact
    },
  ];

  const getStepList = () => {
    // Generic list while we want for user to select Account and Survey Type
    if (!settings) return getStartPageLayout().map(x => ({title: x.title}));

    switch (settings.orderingPageLayoutType) {
      case LENDER_APPRAISAL:
      case LENDER_NON_APPRAISAL:
        return getLenderPageLayout.map(x => ({title: x.title}));
      case INSURANCE:
        return insurancePageLayout.map(x => ({title: x.title}));
      case COMMERCIAL:
        return commercialPageLayout.map(x => ({title: x.title}));
    }
  };

  const getComponentForStep = index => {
    // Start with Product before user chooses account and survey type
    if (!settings) return getStartPageLayout()[0].component;

    switch (settings.orderingPageLayoutType) {
      case LENDER_APPRAISAL:
      case LENDER_NON_APPRAISAL:
        return getLenderPageLayout[index].component;
      case INSURANCE:
        return insurancePageLayout[index].component;
      case COMMERCIAL:
        return commercialPageLayout[index].component;
    }
  };

  const getTotalSteps = () => getStepList().length;

  const getTerminology = () => settings?.terminologyType;

  const getPageLayout = () => settings?.orderingPageLayoutType;

  const getHandlingFeatures = () => settings?.caseHandlingFeatures;

  const getPaymentTypeOptions = () => {
    let options = [];
    if (settings?.availablePaymentTypes?.includes(PAY_NOW)){
      options.push({
        label: "Pay Now",
        value: PAY_NOW
      });
    }
    if (settings?.availablePaymentTypes?.includes(DEFER_PAYMENT)){
      options.push({
        label: "Send payment request to borrower",
        value: DEFER_PAYMENT
      });
    }
    if (settings?.availablePaymentTypes?.includes(MUELLER_INVOICE)){
      options.push({
        label: "Pay by Mueller Invoice",
        value: MUELLER_INVOICE
      });
    }
    return options;
  };

  const getSupplements = () => settings?.supplements;

  return {
    updateSettings,
    getStepList,
    getComponentForStep,
    getTotalSteps,
    getTerminology,
    getPageLayout,
    getHandlingFeatures,
    getPaymentTypeOptions,
    getSupplements,
  };
};

export default useWebOrderSettings;